import React from "react";
import type { FC } from "react";

import { createDisplayNameForCoreInputTextElement } from "../../utils/getDisplayName";
import { createTestIdForCoreInputTextElement } from "../../utils/getTestId";

import type { InputTextBottomProps } from "../../types";

const INPUT_TEXT_BOTTOM_TEST_ID = createTestIdForCoreInputTextElement("bottom");

const CoreInputTextBottom: FC<InputTextBottomProps> = ({ children }) => {
    return children ? (
        <div data-tsid={INPUT_TEXT_BOTTOM_TEST_ID}>{children}</div>
    ) : null;
};

CoreInputTextBottom.displayName =
    createDisplayNameForCoreInputTextElement("Bottom");

export default CoreInputTextBottom;
